import React from "react";
import Grid3 from "../../components/Grid3";
import CardBox from "../../components/GalleryCard";
import { connect } from "react-redux";
import { HttpModule } from "../../services/http.module";
import Typo from "@material-ui/core/Typography";
import LoadingIcon from "@material-ui/core/CircularProgress";
import "../galleryStyles.scss";

export class ImageGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loadingStatus: 0, // 0 none, 1 request, 2 Loaded, 3 Error
    };
    this.#dispatcher = props.dispatch;
  }

  #dispatcher = undefined;

  GetData = () => {
    this.setState({ loadingStatus: 1 }, () => {
      HttpModule.GetGallary()
        .then((data) => {
          this.setState(
            {
              data: data,
            },
            () => {
              this.#dispatcher({
                type: "SET",
                payload: data,
              });

              this.setState({
                loadingStatus: 2,
              });
            }
          );
        })
        .catch(() => {
          this.setState({
            loadingStatus: 3,
          });
        });
    });
  };

  componentDidMount() {
    if (this.props.Gallery.info.length < 1) this.GetData();
    else this.setState({ data: this.props.Gallery.info, loadingStatus: 2 });
  }

  render() {
    return (
      <div className="row pt-5 mt-5 fadeUpAn">
        <div className="col-12 mb-3">
          <Typo variant="h2" className="font-weight-bold text-center">
            گالری تصاویر
          </Typo>
        </div>
        <div className="col-12 fadeUpAn">
          {this.state.loadingStatus === 0 ? (
            <> </>
          ) : this.state.loadingStatus === 1 ? (
            <div className="row">
              <div className="col-4 m-auto text-center p-5">
                <LoadingIcon className="m-auto" color="primary" />
              </div>
            </div>
          ) : this.state.loadingStatus === 2 ? (
            <>
              {this.state.data ? (
                <Grid3 parentClass="fadeUpAn">
                  {this.state.data.map((item, index) => (
                    <div className='mt-3' key={`G-${index}-${item._id}`}>
                      <CardBox
                        key={`G-${index}-oooo${item._id}`}
                        title={item.title}
                        description={item.description}
                        imageUrl={item.url}
                        postUrl={`${item._id}`}
                        history={this.props.history}
                        reduxDispatcher={this.#dispatcher}
                      />
                    </div>
                  ))}
                </Grid3>
              ) : (
                <> </>
              )}
            </>
          ) : (
            <>
              <div className="row mt-5 fadeUpAn">
                <div className="col-12 text-center">
                  <Typo
                    align="center"
                    className="text-danger font-weight-bold"
                    variant="h5"
                  >
                    خطا در دریافت اطلاعات
                  </Typo>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;
export default connect(mapStateToProps)(ImageGallery);
